// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldPaymentsCount_labelContainer__XdSTd"};